export default {
    isProcessedUploadedSuccessfull: [],
    processPayroll: [],
    closedPayroll: [],
    getAllCreatePayroll: [],
    getAllLogHours: [],
    getAllOvertime: [],
    getAllEarnings: [],
    getAllDeductions: [],
    getAllLoans: [],
    uploadedLogHours: [],
    uploadedOvertimeHours: [],
    uploadedEarnings: [],
    uploadedDeductions: [],
    uploadedLoans: [],
    generatereports: []
}